import { logWrapper } from '../utils';

export default {
  elementModel: [
    'runtimeConstant',
    'ETaskTypes',
    function (runtimeConstant, ETaskTypes) {
      function Element(data) {
        this.id = data.Id;
        this.idLane = data.IdLane;
        this.name = data.Name;
        this.description = data.Description;
        this.type = data.Type;
        this.duration = data.Duration;
        this.isDescriptionOptional = data.IsDescriptionOptional;

        this.links = data.Links;
      }

      function currentStepType() {
        var type = '';
        switch (this.currentStep.elementType) {
          case 0:
            type = 'REVIEW';
            break;
          case 1:
            type = 'NOTIFICATION';
            break;
          case 2:
            type = 'DECISION';
            break;
          case 3:
            type = 'START';
            break;
          case 4:
            type = 'END';
            break;
        }

        return type;
      }

      function icon() {
        var icon = '';

        switch (this.element.Type) {
          case ETaskTypes.Review:
            icon = 'fa fa-edit';
            break;
          case ETaskTypes.Notification:
            icon = 'fa fa-envelope';
            break;
          case ETaskTypes.Approve:
            icon = 'fa fa-search-plus';
            break;
          case ETaskTypes.ApproveWithSignature:
            icon = 'fa fa-search-plus';
            break;
          case ETaskTypes.Training:
            icon = 'fa fa-group';
            break;
          case ETaskTypes.Distribution:
            icon = 'fa fa-search-plus';
            break;
          case ETaskTypes.Analysis:
            icon = 'fa fa-line-chart';
            break;
          case ETaskTypes.Start:
            icon = 'fa fa-file-o';
            break;
        }

        return icon;
      }

      function run() {
        try {
          Element.prototype = {
            currentStepType: logWrapper(
              currentStepType,
              runtimeConstant.isDebugModelsInternals
            ),
            icon: logWrapper(icon, runtimeConstant.isDebugModelsInternals),
          };

          return Element;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
